const comments = [
  {
    name: '吃瓜老司机',
    time: '2小时前',
    text: '终于找到稳定的在线吃瓜入口了！之前每次域名一变就找不到，现在直接收藏这个导航页，随时都能获取91在线吃瓜网的最新地址，太方便了。',
  },
  {
    name: '深夜追更人',
    time: '5小时前',
    text: '线路一速度真快，备用网址也很稳。在线吃瓜这个入口导航做得不错，推荐给身边的朋友了，大家都说好用。',
  },
  {
    name: '吃瓜不嫌事大',
    time: '8小时前',
    text: '在线吃瓜官方线路更新很及时，早上发现旧入口打不开，来这一看果然已经更新了最新入口。一键直达，不迷路！',
  },
  {
    name: '低调围观群众',
    time: '1天前',
    text: '移动端体验很好，不用下载APP就能流畅访问。在线吃瓜的备用网址也很全，有好几条线路可以切换，再也不怕打不开了。',
  },
  {
    name: '瓜田守望者',
    time: '2天前',
    text: '用了快半年了，在线吃瓜真的是最靠谱的吃瓜通道。每次入口变更都能第一时间在这里找到更新，已经成了我浏览器首页了。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100/50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-secondary-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-chat-3-line text-secondary-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">用户心声</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((c, i) => (
            <div key={i} className="p-5 rounded-xl bg-background-50 border border-background-300/30">
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center flex-shrink-0 text-sm font-semibold text-primary-400">
                  {c.name.charAt(0)}
                </span>
                <div>
                  <span className="text-sm font-medium text-foreground-300 block">{c.name}</span>
                  <span className="text-xs text-foreground-600">{c.time}</span>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}